export default __webpack_public_path__ + "static/media/icon-congrats-success-star.4d9db1cd.svg";